import { useQuery } from "@apollo/client/react";
import useTimeZone from "hooks/useTimeZone";
import { GetDashboardData } from "./usageData.gql";

export default function useUsageData({ eventNames, startDate, endDate, siteId }) {
  const { overrideToSiteTimeZone } = useTimeZone();

  const { data } = useQuery(GetDashboardData, {
    variables: {
      endDate: overrideToSiteTimeZone(endDate),
      eventNames,
      siteId,
      startDate: overrideToSiteTimeZone(startDate),
    },
  });

  return data?.usageData;
}
